jQuery(document).ready(function(){

  
const owl_hero = jQuery('#hero-carousel');

  owl_hero.owlCarousel({
      loop:false,
      margin:0,
      nav:false,
      dots:false,
      responsive:{
          0:{
              items:1
          },
          600:{
              items:1
          },
          1000:{
              items:1
          }
      }
  })

  const owl_hh = jQuery('#testimonials');

  owl_hh.owlCarousel({
      loop:false,
      margin:0,
      nav:true,
      navText:['<img src="//vedicinalsusa.com/cdn/shop/t/9/assets/lets-icons_arrow-left-light.svg?v=18392195741037468921762945971">','<img src="//vedicinalsusa.com/cdn/shop/t/9/assets/lets-icons_arrow-left-light.svg?v=18392195741037468921762945971">'],
      dots:false,
      center:true,
      responsive:{
          0:{
              items:1
          },
          600:{
              items:1
          },
          1000:{
              items:1.75
          }
      }
  })
  
})



  

  
// jQuery(window).on('scroll', function() {
//   var scrollTop = jQuery(window).scrollTop();


//   // Scale down rotation to make it slower
//   var rotation = (scrollTop / 4) % 360;

//   jQuery('.wheel-image').css({
//       'transform': 'rotate(' + rotation + 'deg)'
//   });
// });

